import * as React from 'react'
import { TaskMainDropdownConnected } from './TaskMainDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TEAM_A_ID } from 'mockState'

export const TaskMainDropdownExamples = () => {
  return (
    <div className="TaskMainDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskMainDropdownConnected taskId={MOCK_TEAM_A_ID} />
      </Provider>
    </div>
  )
}
